<template>
    <el-row class="border-bottom">
        <el-col :span="5">
            <div>
                <el-checkbox v-model="module.checked" :disabled="isView||module.disabled" @change="changeCurModule">
                    <span class="font12px">{{module.display_name}}</span>
                </el-checkbox>
                <CheckAllBtn class="ml20" :data="module" @change="checkAllChange" v-if="!isView"/>
            </div>
            <div class="line-height-normal pl10" v-if="module.checked">
                <el-button class="config-btn" type="text" v-if="['intelligent_managed_rule', 'ad_batch_adjustment_page'].includes(module.name) && (module.adjustment_operation&&module.adjustment_operation.length>0)" @click="showAdBatchModal">操作项权限</el-button>
                <el-button class="config-btn" type="text" v-if="module.fields&&module.fields.length>0" @click="showFieldsModal">字段权限</el-button>
                <el-button class="config-btn" type="text" v-if="module.dimension&&module.dimension.length>0" @click="showDimensionsModal">维度权限</el-button>
                <el-button class="config-btn" type="text" v-if="hasOptionalRole(module)" @click="showConfigOptionalRoleModal">可选角色</el-button>
                <el-button class="config-btn" type="text" v-if="hasOptionalTable(module)" @click="showConfigDataTableModal">可查看配置表</el-button>
                <el-button class="config-btn" type="text" v-if="module.statistical_period&&module.statistical_period.length>0" @click="showStatisticalPeriodModal">统计周期</el-button>
                <el-button class="config-btn" type="text" v-if="module.notifier&&(module.notifier.length>0)" @click="showNotifierModal">通知人</el-button>
                <el-button class="config-btn" type="text" v-if="module.name ==='retry_data_page'" @click="handleRetryDataClick">抓取时段</el-button>
                <el-button class="config-btn" type="text" v-if="['material_list', 'material_query_analysis_page','work_order_dashboard_page','wos_schedule_manage'].includes(module.name)&&(module.data_permission&&module.data_permission.length>0)" @click="showDataPermissionModal">数据权限</el-button>
            </div>
        </el-col>
        <el-col :span="15">
            <template v-if="module.func&&module.func.length>0">
                <el-checkbox v-for="item in module.func" class="fun-checkbox" :label="item.id" v-model="item.checked" :disabled="item.disabled||isView" :key="item.id" @change="handleChangeFuncItem(item,$event)">
                    {{item.display_name}}
                    <el-tooltip v-if="getItemTitle(item).length>0" class="item" effect="dark" :content="getItemTitle(item)" placement="top">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </el-checkbox>
            </template>
            <div v-else>
                <p class="text-color-gray">暂无数据</p>
            </div>
        </el-col>
        <el-col :span="4">
            <!--信息管理-标签维护页面:禁用数据权限设置-->
            <div class="mt6 mb6" v-if="module.name=='tag_management_page'||module.name=='project_management_page'">
                <el-radio-group disabled :title="module.name=='tag_management_page'?'此页面显示所有标签':'此页面显示所有项目'">
                    <el-radio label="2" disabled>自身权限</el-radio>
                    <el-radio label="1" disabled>全部数据</el-radio>
                </el-radio-group>
            </div>
            <!--首页-运营负责人:不展示数据权限设置-->
            <div class="mt6 mb6" v-else>
                <el-radio-group v-model="module.role_action" @change="changeRoleAction" :disabled="isView||module.disabled||isDashboardPage(module)">
                    <el-radio label="2" :title="isDashboardPage(module)?'该页面根据登陆成员的部门数据权限查询对应成员的数据，若需查看全部账户&成员数据可修改部门数据权限达到此目的！':''" :disabled="['bloc_star_list'].includes(module.name)">自身权限</el-radio>
                    <el-radio label="1" :title="isDashboardPage(module)?'该页面根据登陆成员的部门数据权限查询对应成员的数据，若需查看全部账户&成员数据可修改部门数据权限达到此目的！':''" :disabled="module.role_action_config==2||module.name=='organization_management_page'||['wos_schedule_manage','capacity_config_list'].includes(module.name)">全部数据</el-radio>
                </el-radio-group>
            </div>
        </el-col>
    </el-row>
</template>

<script>
    import CheckAllBtn from './checkAllBtn.vue';
    import {statisticalPeriodModal,configOptionRoleModal,configOptionTableModal,tagFieldsConfigModal,baseRoleFieldModal,tabRoleFieldModal, retryDataModal,dataPermissionModal} from './modal/index';
    import util from '@/libs/utils';

    export default {
        name: "ModuleContent",
        components:{
            CheckAllBtn,
        },
        props: {
            module:{
                type: Object,
                default: function () {
                    return {}
                }
            },
            isView:{
                type: Boolean,
                required:false,
                default:false,
            },
            tagEditable:{
                type: Object,
                required: true
            },
            dataDays:{
                type:[String,Number]
            },
            periodConfig:Object,
            roleList:Array,
            tableList:Array,
            specialConfig: Object
        },
        created(){
            // 数据权限范围固定规则（与排单管理页/产能配置/集团星级口径对齐·硬编码 by name·同 organization_management_page 模式）：
            //   排单管理 wos_schedule_manage / 产能配置 capacity_config_list → 默认自身权限·禁全部数据（归一化历史全部为自身）
            //   集团星级 bloc_star_list → 禁自身权限·默认全部数据
            const n = (this.module||{}).name;
            if(['wos_schedule_manage','capacity_config_list'].includes(n)){
                if(String(this.module.role_action) !== '2') this.module.role_action = '2';
            }else if(n === 'bloc_star_list'){
                if(String(this.module.role_action) !== '1') this.module.role_action = '1';
            }
        },
        methods:{
            hasOptionalRole(module = {}){
                let specialFunc = module.special_func||[];
                return specialFunc.map(item=>item.name).includes('optional_role');
            },
            hasOptionalTable(module = {}){
                let specialFunc = module.special_func||[];
                return specialFunc.map(item=>item.name).includes('optional_config_table');
            },
            checkAllChange(data,val){
                if(data.disabled&&data.name!='home') return console.log('不可操作');
                this.$emit('check-all-change',data,val);
            },
            changeCurModule(val){
                console.log('changeCurModule',val);
                if(val){
                    let pid = this.module.pid;
                    this.$emit('check-parents',pid);
                }else{
                    // 模块取消后，取消所有children权限
                    this.checkAllChange(this.module,false);
                }
            },
            // 广告批量调控 操作项权限
            showAdBatchModal() {
                tabRoleFieldModal({
                    props: {
                        isView: this.isView,
                        page:{...this.module},
                        fields: this.module.adjustment_operation||[],
                        tagEditable:this.tagEditable,
                        title:'操作项权限',
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            console.log('onSubmit：操作项权限1',data);
                            this.$emit('save-adjustment',data);
                        },
                    }
                })
            },
            showFieldsModal(){
                console.log('showFieldsModal',this.module);

                /* 基础信息管理：集团、客户、账户、计划、产品、项目、代理等tab页 */
                let tagSubPage = [
                    'plat_management_page',
                    'bloc_management_page',
                    'company_management_page',
                    'account_management_page',
                    'plan_management_page',
                    'app_management_page',
                    'project_management_page',
                    'plat_username_page',
                ];

                if(tagSubPage.includes(this.module.name)){
                    /* 标签管理：查看&编辑 权限 */
                    tagFieldsConfigModal({
                        props: {
                            isView: this.isView,
                            page:{...this.module},
                            fields: this.module.fields||[],
                            tagEditable:this.tagEditable,
                        },
                        cbs:{
                            onSubmit:(page,viewChecked,editChecked)=>{
                                console.log('onSubmit：标签管理-字段权限',page,viewChecked,editChecked);
                                this.$emit('save-tag-fields',page,viewChecked,editChecked);
                            },
                        }
                    })
                }else {
                    console.log('deep',util.getArrayDepth(this.module.fields||[],'children'));
                    let depth = util.getArrayDepth(this.module.dimension||[],'children');
                    if(depth==3){
                        tabRoleFieldModal({
                            props: {
                                isView: this.isView,
                                page:{...this.module},
                                fields: this.module.fields||[],
                                tagEditable:this.tagEditable,
                                actionType:'fields'
                            },
                            cbs:{
                                onSubmit:(data)=>{
                                    console.log('onSubmit：字段权限',data);
                                    this.$emit('save-field',data);
                                },
                            }
                        })
                    }else{
                        baseRoleFieldModal({
                            props: {
                                isView: this.isView,
                                page:{...this.module},
                                fields: this.module.fields||[],
                                tagEditable:this.tagEditable,
                                actionType:'fields'
                            },
                            cbs:{
                                onSubmit:(data)=>{
                                    console.log('onSubmit：字段权限',data);
                                    this.$emit('save-field',data);
                                },
                            }
                        })
                    }
                }
            },
            showDimensionsModal(){
                let depth = util.getArrayDepth(this.module.dimension||[],'children');
                if(depth==3){
                    tabRoleFieldModal({
                        props: {
                            isView: this.isView,
                            page:{...this.module},
                            fields: this.module.dimension||[],
                            tagEditable:this.tagEditable,
                            actionType:'dimensions'
                        },
                        cbs:{
                            onSubmit:(data)=>{
                                console.log('onSubmit：维度权限',data);
                                this.$emit('save-dimension',data);
                            },
                        }
                    })
                }else{
                    baseRoleFieldModal({
                        props: {
                            isView: this.isView,
                            page:{...this.module},
                            fields: this.module.dimension||[],
                            actionType:'dimensions'
                        },
                        cbs:{
                            onSubmit:(data)=>{
                                console.log('onSubmit：维度权限',data);
                                this.$emit('save-dimension',data);
                            },
                        }
                    })
                }
            },
            showConfigDataTableModal(){
                console.log('showConfigDataTableModal', this.$store,this.module);

                let tableList = this.tableList ||[];
                configOptionTableModal({
                    props: {
                        isView: this.isView,
                        page:{...this.module},
                        optionList: tableList,
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            console.log('onSubmit：配置可选角色',this.module,data);
                            this.$emit('save-tables',this.module,data);
                        },
                    }
                });
            },
            showConfigOptionalRoleModal(){
                console.log('showConfigOptionalRoleModal',this.module);
                configOptionRoleModal({
                    props: {
                        isView: this.isView,
                        page:{...this.module},
                        roleList:this.roleList,
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            console.log('onSubmit：配置可选角色',this.module,data);
                            this.$emit('save-roles',this.module,data);
                        },
                    }

                });
            },
            showDataPermissionModal(){
                /* 工单管理素材库页面-数据权限(需求方/制作方) */
                console.log('showDataPermissionModal',this.module);
                dataPermissionModal({
                    props: {
                        isView: this.isView,
                        page:{...this.module},
                        // roleList:this.roleList,
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            console.log('onSubmit：数据权限(需求方/制作方)',this.module,data);
                            this.$emit('save-data-permission',this.module,data);
                        },
                    }

                });

            },
            showStatisticalPeriodModal(){
                statisticalPeriodModal({
                    props: {
                        isView: this.isView,
                        page:{...this.module},
                        fields:[...this.module.statistical_period],
                        periodConfig:this.periodConfig,
                    },
                    cbs:{
                        onSubmit:(page,data)=>{
                            console.log('onSubmit：统计周期',page,data);
                            this.$emit('save-period',page,data);
                        },
                    }
                });
            },
            showNotifierModal(){
                console.log('showNotifierModal',this.module);
                baseRoleFieldModal({
                    props: {
                        isView: this.isView,
                        page:{...this.module},
                        fields: this.module.notifier||[],
                        actionType:'notifier'
                    },
                    cbs:{
                        onSubmit:(data)=>{
                            console.log('onSubmit：通知人权限',data);
                            this.$emit('save-notifier',data);
                        },
                    }
                })
            },
            handleChangeFuncItem(item,val){
                console.log('handleChangeFuncItem',item,val);
                if(val==true&&item.auto_check){
                    let checkArr = item.auto_check.split(',');
                    this.$emit('auto-check-func',this.module,checkArr,val);
                }else if(val===false&&item.auto_uncheck){
                    let checkArr = item.auto_uncheck.split(',');
                    this.$emit('auto-check-func',this.module,checkArr,val);
                }else if(val===true) {
                    this.$emit('auto-check-func',this.module,[item.id],val);
                }
            },
            changeRoleAction(val){
                console.log('changeRoleAction',this.module,val);
            },
            getItemTitle(item){
                let configStr = item.config||"{}";
                let config = JSON.parse(configStr)||{};
                return config.title||'';
            },
            isDashboardPage(page){
                let pageName = (page||{}).name||'';
                return [
                    'file_whitelist_page',
                    'file_separate_queue_page',
                    'yy_director',
                    'xs_director',
                    'kf_director',
                    'project_management_page1',
                    'creative_team_list',
                    'size_list',
                    'video_tag_list',
                    'img_tag_list',
                    'plat_management_page',
                    'material_compare_page',
                    'work_order_label_list',
                    'mp_organization_management_page'
                ].includes(pageName);
            },
            // 抓取时段弹框
            handleRetryDataClick() {
                const onSubmit = (data)=> {
                    this.$emit('save-retry-data', data)
                    vm.close()
                }
                const { vm } = retryDataModal({
                    props: {
                        isView: this.isView,
                        retry_period:this.specialConfig.retry_period,
                    },
                    cbs: {
                        onSubmit
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .border-bottom{
        border-bottom: solid 1px #d7d7d7;
    }
    .config-btn{
        padding: 3px 0;
    }
    .line-height-normal{
        line-height: normal;
    }

    .fun-checkbox{
        min-width: 150px;
        margin-right: 10px;
    }
</style>
